import { Badge } from "@/components/ui/badge";

/**
 * Sprint 6 / C11.2 — общий бейдж severity для всех карточек расхождений
 * (DiscrepancyCard / DiscrepancyMatrixCard / DiscrepancyGrandTotalCard).
 *
 * До C11.2 этот компонент был трижды продублирован inline в card-файлах
 * с идентичной реализацией.
 */
export function SeverityBadge({ severity }: { severity: "error" | "warning" }) {
	const cls =
		severity === "error"
			? "bg-red-100 text-red-800 border-transparent"
			: "bg-yellow-100 text-yellow-800 border-transparent";
	return <Badge className={`text-[10px] uppercase ${cls}`}>{severity}</Badge>;
}
